// extracted by mini-css-extract-plugin
export default {"record":"record___b999a1cc68cf3fbe","inner":"inner___d2df7412d0f024e6","outer":"outer___aaef1b1ee7d09cce","pulsate":"pulsate___cb59ab61182908b9"};